import type {
  AdminEraseUserInput,
  AdminWithdrawConsentInput,
  DeleteOwnAccountInput,
  ErasureLogRow,
  GuestSearchRow,
  MailingListSummary,
  UserConsentsView,
} from '@creativitas/shared';
import { apiFetch } from '@/lib/api';

/** Согласия, отписка и удаление данных (docs/PRIVACY.md). */

export const MY_CONSENTS_KEY = ['me', 'consents'] as const;

export const fetchMyConsents = (): Promise<UserConsentsView> => apiFetch<UserConsentsView>('/me/consents');

export const setMyConsent = (consentId: string, granted: boolean): Promise<UserConsentsView> =>
  apiFetch<UserConsentsView>(`/me/consents/${encodeURIComponent(consentId)}`, {
    method: 'PUT',
    body: { granted },
  });

export const deleteMyAccount = (input: DeleteOwnAccountInput): Promise<{ ok: true }> =>
  apiFetch<{ ok: true }>('/me/delete', { method: 'POST', body: input });

/** Токен уходит телом: в ссылке он после решётки и в журналы веб-сервера не попадает. */
export const unsubscribe = (token: string): Promise<{ ok: true; consentText: string | null }> =>
  apiFetch<{ ok: true; consentText: string | null }>('/privacy/unsubscribe', {
    method: 'POST',
    body: { token },
  });

/* Администрирование ------------------------------------------------------ */

export const ADMIN_PRIVACY_KEY = ['admin', 'privacy'] as const;
export const adminUserConsentsKey = (userId: string) => ['admin', 'users', userId, 'consents'] as const;

export const fetchUserConsents = (userId: string): Promise<UserConsentsView> =>
  apiFetch<UserConsentsView>(`/admin/users/${userId}/consents`);

export const withdrawUserConsent = (
  userId: string,
  consentId: string,
  input: AdminWithdrawConsentInput,
): Promise<UserConsentsView> =>
  apiFetch<UserConsentsView>(`/admin/users/${userId}/consents/${encodeURIComponent(consentId)}/withdraw`, {
    method: 'POST',
    body: input,
  });

export const eraseUser = (userId: string, input: AdminEraseUserInput): Promise<{ ok: true }> =>
  apiFetch<{ ok: true }>(`/admin/users/${userId}/erase`, { method: 'POST', body: input });

export const fetchMailingLists = (): Promise<{ items: MailingListSummary[] }> =>
  apiFetch<{ items: MailingListSummary[] }>('/admin/privacy/mailing-lists');

/** Обычная ссылка, а не запрос: файл скачивает браузер, вход — по той же куке. */
export const mailingListExportUrl = (consentId: string): string =>
  `/api/admin/privacy/mailing-lists/${encodeURIComponent(consentId)}/export`;

export const searchGuests = (q: string): Promise<{ items: GuestSearchRow[] }> =>
  apiFetch<{ items: GuestSearchRow[] }>(`/admin/privacy/guests?q=${encodeURIComponent(q)}`);

export const eraseGuest = (participantId: string): Promise<{ ok: true }> =>
  apiFetch<{ ok: true }>(`/admin/privacy/guests/${participantId}/erase`, { method: 'POST' });

export const fetchErasures = (): Promise<{ items: ErasureLogRow[] }> =>
  apiFetch<{ items: ErasureLogRow[] }>('/admin/privacy/erasures');
